export default "__VITE_ASSET__0nsRJ2Yn__"